import {
  FETCH_RANK_INDICATORS,SHOW_MESSAGE,RANK_INDICATORS_CHANGE,FETCH_RANK_INDICATORS_SUCCESS
} from '../constants/ActionTypes';


export const showMessage = (message) =>{
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
}

export const fetchRankIndicators = () => {
  return {
    type: FETCH_RANK_INDICATORS
  };
};


export const onRankIndicatorsChange = (value) => {
  return {
    type: RANK_INDICATORS_CHANGE,
    payload:value
  };
};

export const fetchRankIndicatorsSuccess = (value)=>{
  return {
    type: FETCH_RANK_INDICATORS_SUCCESS,
    payload:value
  };
}